import type { FaireProductEntity } from "../../entity_types/product";

export const p_5yzf6ujpxg: FaireProductEntity = {
  token: "p_5yzf6ujpxg",
  type: "product",
  name: "Ceriello Homemade Marinara Sauce",
  brandToken: "b_9d6nx4c74q",
  brandName: "Ceriello Fine Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/e95a7967bcb73e5e3029f6f7f3e87ba2eddb429041a28c25d1dcda0a3877e44f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1e38f1da06432dea0e671e1751aa05f44da49b737f9778f69b40317668efa64.png",
    "https://cdn.faire.com/fastly/d7f6aa285f36310b152e11281372712f2ee900f05e584e4c01a816aa95d5f160.jpeg",
  ],
  priceDollars: 3.17,
  description:
    'We have been making these sauces in our store kitchen for over 20 years--hand-stirred and hand-filled in heat-sealed jars. We use only Italian-grown San-Marzano Style tomatoes, fresh produce and top-quality spices.\n\nCeriello\'s Marinara sauce begins with fresh Italian plum tomatoes, crushed by hand and then seasoned with herbs including fresh parsley & basil, and then simmered slowly to blend the flavors. It’s delicious when served with stuffed pastas like ravioli, manicotti & stuffed shells.\n\nOur kitchen is NY State inspected and USDA inspected. Sealed jars are shelf-stable for 2 years and good in the refrigerator, after opening, for about a week. A 15oz jar is good for about one pound of pasta (3-4 people). A 30oz jar for about two pounds (7-8 people). \n\nVegetarian. No sugar, wheat, or nut products added, though we are not an allergen-free environment.\n\nUse Discount Code "CASE" take $1 off each bottle of dressing or sauce when you buy 12.\n*Discount already included on whole case purchases*',
  tags: [],
  msrpDollars: 6.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:11.172Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
